export default {
      id: "unit-list-temperature-usage",
      viewBox: "0 0 5 9",
      url: __webpack_public_path__ + "img/icons.svg#unit-list-temperature",
      toString: function () {
        return this.url;
      }
    }